import { IMasterAddress } from '../../../../api/addressSearch/addressSearch';
import ValueFormatters from '../valueFormatters';

export type IValidatorAddress = Pick<IMasterAddress, 'state' | 'city' | 'street'>;

export class BanchiValidator {
    public static containsNumber(str: string) {
        return /[0-9０１２３４５６７８９一二三四五六七八九十]/.test(str);
    }

    /**
     *  banchi vaildator
     * if userAddress include banchi address return true, otherwise return false.
     * @param userAddress
     * @param masterAddress
     * @returns boolean
     * */
    public static haveBanchiValidator(
        userAddress: IValidatorAddress,
        masterAddress: IValidatorAddress,
    ) {
        const NO_BANCHI_KEYWORD = '無番地';
        const PATTERN_ARABIC_NUMERALS = /^.*[0-9０-９].*$/;
        const PATTERN_KANJI_NUMERALS = /^.*[一二三四五六七八九十].*$/;
        const PATTERN_BANCHI = [
            /^.*[一二三四五六七八九十]丁目.*$/,
            /^.*[一二三四五六七八九十]番.*$/,
            /^.*[一二三四五六七八九十][-—ー][一二三四五六七八九十].*$/,
        ];

        const masterCity = ValueFormatters.trimExtraSpaces(masterAddress.city);
        const masterStreet = ValueFormatters.trimExtraSpaces(masterAddress.street);
        const city = userAddress.city ?? '';
        const street = userAddress.street ?? '';

        if (street.includes(NO_BANCHI_KEYWORD) || city.includes(NO_BANCHI_KEYWORD)) {
            return true;
        }

        if (street.match(PATTERN_ARABIC_NUMERALS) || city.match(PATTERN_ARABIC_NUMERALS)) {
            return true;
        }

        if (!street.match(PATTERN_KANJI_NUMERALS) && !city.match(PATTERN_KANJI_NUMERALS)) {
            return false;
        }
        if (PATTERN_BANCHI.some((pattern) => street.match(pattern) || city.match(pattern))) {
            return true;
        }

        const userInputAddress = city.replace(masterCity, '') + street.replace(masterStreet, '');
        return !!userInputAddress.match(PATTERN_KANJI_NUMERALS);
    }

    /**
     *
     * if user address not master address's sub address, return false, otherwise, return true.
     * @param userAddress
     * @param masterAddress
     * */
    public static subAddressValidator(
        userAddress: IValidatorAddress,
        masterAddress: IValidatorAddress,
    ) {
        const userAddressStr = userAddress.state + userAddress.city + userAddress.street;
        const masterAddressStr = masterAddress.state + masterAddress.city + masterAddress.street;

        if (userAddressStr.indexOf(masterAddressStr) > -1) {
            return true;
        }

        return false;
    }
}
